export default function init() {
  // When the user clicks on the button, scroll to the top of the document
  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  // Get the button:
  const mybutton = document.getElementById('scroll-to-top-btn');
  mybutton.addEventListener('click', topFunction);
  let lastScrollTop = 0;
  // ad
  function scrollFunction() {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (
      (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500)
      && st < lastScrollTop
    ) {
      mybutton.style.display = 'block';
    } else {
      mybutton.style.display = 'none';
    }
    lastScrollTop = st <= 0 ? 0 : st;
  }
  // When the user scrolls down 500px from the top of the document, show the button
  window.addEventListener('scroll', scrollFunction, false);
}
